// src/pages/Planner/PlannersPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader, Plus } from "lucide-react";
import api from "@/lib/axios";

export default function PlannersPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/planners");
        if (alive) setRows(Array.isArray(data) ? data : []);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div className="min-h-screen p-6 bg-gradient-to-br from-black via-gray-900 to-gray-950">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h1 className="text-2xl font-extrabold text-white">👥 Planners</h1>
          <p className="text-gray-400 text-sm">Manage the planner registry.</p>
        </div>
        <Link
          to="/planners/new"
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-violet-600 hover:bg-violet-700 text-white"
        >
          <Plus className="w-4 h-4" /> New Planner
        </Link>
      </div>

      <div className="rounded-xl border border-white/10 overflow-hidden bg-white">
        <div className="px-4 py-3 bg-gray-100 font-semibold text-gray-900">
          Planner Registry
        </div>
        {loading ? (
          <div className="px-4 py-6 text-gray-600 flex items-center gap-2">
            <Loader className="w-4 h-4 animate-spin" /> Loading…
          </div>
        ) : rows.length === 0 ? (
          <div className="px-4 py-6 text-gray-600">No planners found.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm text-gray-900">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left">Name</th>
                  <th className="px-4 py-2 text-left">ID</th>
                  <th className="px-4 py-2 text-left">Created At</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((p) => (
                  <tr key={p.planner_id} className="odd:bg-white even:bg-gray-50 border-t">
                    <td className="px-4 py-2">{p.planner_name}</td>
                    <td className="px-4 py-2">{p.planner_id}</td>
                    <td className="px-4 py-2">
                      {(p.created_at || "").toString().slice(0, 19).replace("T", " ")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
